<div class="action-config-wrapper" style="max-width: 550px">
  <div class="config-action">
    <nb-stepper orientation="horizontal" selectedIndex="0">
      <nb-step [label]="labelOne">
        <ng-template #labelOne>Say Somethings</ng-template>
        <form>
          <nb-radio-group
            [(ngModel)]="data.option"
            class="choice-option"
            (ngModelChange)="handleAudio($event)"
          >
            <nb-radio *ngFor="let option of options" [value]="option.id">{{
              option.name
            }}</nb-radio>
          </nb-radio-group>
        </form>

        <div
          class="form-group"
          style="padding: 1rem 0; width: 100%; display: inline-grid"
        >
          <text-to-speech #textToSpeech></text-to-speech>
          <nb-card class="select-audio" [ngClass]="{ show: data.option == 1 }">
            <nb-card-header class="audio-list-style">
              <span>Audio List</span>
              <nb-icon
                class="ms-2"
                style="color: #929bb3; width: 15px"
                nbTooltip="Select the audio you want to play. The audio list will play in order and continuously. If no audio is selected, the system will use text to speech."
                nbTooltipPlacement="bottom"
                nbTooltipStatus="basic"
                nbTooltipTrigger="hover"
                icon="question-mark-circle-outline"
              >
              </nb-icon
            ></nb-card-header>
            <nb-card-body>
              <simple-audio-player
                #audioPlayer
                [events]="eventsSubject.asObservable()"
              ></simple-audio-player>
              <button
                nbButton
                size="small"
                status="primary"
                (click)="showModify()"
              >
                <nb-icon icon="plus-outline"></nb-icon> Add
              </button>
            </nb-card-body>
          </nb-card>
        </div>
      </nb-step>
      <nb-step [label]="labelTwo">
        <ng-template #labelTwo>Setting</ng-template>
        <form [formGroup]="formGroup">
          <!-- Ring Strategy -->
          <div class="form-group mb-2">
            <label class="label required mb-2">Ring Strategy</label>
            <nb-icon
              class="ms-1"
              style="color: #929bb3; width: 15px"
              nbTooltip="Select how the system will ring the members"
              nbTooltipPlacement="bottom"
              nbTooltipStatus="basic"
              nbTooltipTrigger="hover"
              icon="question-mark-circle-outline"
            >
            </nb-icon>
            <nb-select
              size="small"
              formControlName="ringStrategy"
              fullWidth
              placeholder="Select strategy"
            >
              <nb-option value="ringall">Ring All</nb-option>
              <nb-option value="sequence">Sequence</nb-option>
              <nb-option value="random">Random</nb-option>
            </nb-select>
            <ng-container
              *ngIf="
                formGroup.get('ringStrategy').invalid &&
                formGroup.get('ringStrategy').touched
              "
            >
              <p class="caption status-danger">Ring strategy is required</p>
            </ng-container>
          </div>

          <!-- Ring Time -->
          <div class="form-group mb-2">
            <label class="label required mb-2">Ring Time (seconds)</label>
            <nb-icon
              class="ms-1"
              style="color: #929bb3; width: 15px"
              nbTooltip="Set how long the phone will ring (0-300 seconds)."
              nbTooltipPlacement="bottom"
              nbTooltipStatus="basic"
              nbTooltipTrigger="hover"
              icon="question-mark-circle-outline"
            >
            </nb-icon>
            <input
              fieldSize="small"
              type="number"
              nbInput
              fullWidth
              formControlName="ringingTime"
              placeholder="Enter ring time in seconds"
              min="0"
              max="300"
            />
            <ng-container
              *ngIf="
                formGroup.get('ringingTime').invalid &&
                formGroup.get('ringingTime').touched
              "
            >
              <p
                class="caption status-danger"
                *ngIf="formGroup.get('ringingTime').errors?.required"
              >
                Ring time is required
              </p>
              <p
                class="caption status-danger"
                *ngIf="
                  formGroup.get('ringingTime').errors?.min ||
                  formGroup.get('ringingTime').errors?.max
                "
              >
                Ring time must be between 0 and 300 seconds
              </p>
            </ng-container>
          </div>

          <!-- Music on Hold -->
          <div class="form-group mb-3">
            <app-music-on-hold
              [musicOnHolds]="musicOnHolds"
              [selectedMohId]="mohIdSelected"
              (selectedMohChange)="handleMohSelect($event)"
              (refreshList)="handleMohRefresh()"
            ></app-music-on-hold>
          </div>

          <!-- Members Selection -->
          <div class="form-group mb-2">
            <nb-card class="select-member">
              <nb-card-header class="audio-list-style">
                <span class="required" >Members List</span>
                <nb-icon
                  class="ms-2"
                  style="color: #929bb3; width: 15px"
                  nbTooltip="Select and arrange members in the order you want them to ring (max 10 members)"
                  nbTooltipPlacement="bottom"
                  nbTooltipStatus="basic"
                  nbTooltipTrigger="hover"
                  icon="question-mark-circle-outline"
                >
                </nb-icon>
              </nb-card-header>
              <nb-card-body>
                <!-- Members List -->
                <nb-accordion
                  *ngIf="selectedMembers.length !== 0"
                  style="padding: 8px; width: 100%"
                  cdkDropList
                  (cdkDropListDropped)="drop($event)"
                >
                  <nb-accordion-item
                    *ngFor="let member of selectedMembers"
                    cdkDrag
                    #item
                    style="cursor: pointer"
                    class="audio-box"
                    [expanded]="false"
                  >
                    <nb-accordion-item-header
                      >{{ member?.extension }}
                      <button
                        ghost
                        type="button"
                        size="small"
                        status="primary"
                        nbButton
                        class="icon-action-ring-group"
                        (click)="removeMember(member); $event.stopPropagation()"
                      >
                        <nb-icon icon="trash-2-outline"></nb-icon>
                      </button>
                    </nb-accordion-item-header>
                    <nb-accordion-item-body>
                      <div class="member-details">
                        <div class="detail-row">
                          <div class="detail-info">
                            <nb-icon icon="person-outline" pack="eva"></nb-icon>
                            <span
                              class="detail-value"
                              [nbTooltip]="member.fullName"
                              nbTooltipPlacement="top"
                              nbTooltipStatus="basic"
                              nbTooltipTrigger="hover"
                              [nbTooltipDisabled]="member.fullName.length <= 50"
                            >
                              {{ member.fullName }}
                            </span>
                          </div>
                        </div>
                      </div>
                    </nb-accordion-item-body>
                  </nb-accordion-item>
                </nb-accordion>

                <!-- Add Button -->
                <button
                  style="margin-top: 1rem"
                  nbButton
                  size="small"
                  status="primary"
                  (click)="showAgentSelector()"
                  [disabled]="selectedMembers.length >= 10"
                >
                  <nb-icon icon="plus-outline"></nb-icon> Add
                </button>
              </nb-card-body>
            </nb-card>
          </div>
        </form>
      </nb-step>
    </nb-stepper>
  </div>
  <footer-action
    (handleCancelAction)="handleCancelAction()"
    (handleSaveAction)="handleSaveAction()"
  ></footer-action>
</div>
